import React from 'react'
import {PageRouter} from './page-router'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {Provider} from 'react-redux'
import {store} from './redux/store'

function App() {
  return (
    <>
      <Provider store={store}>
        <PageRouter />
        <div className="container mt-4">
          <ToastContainer />
        </div>
      </Provider>
    </>
  )
}

export default App
